import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Chip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const CategoriesTableRow = ({
    category,
    index,
    isSelected,
    onRowCheckboxClick,
    onMenuOpen,
}) => {
    const { i18n } = useTranslation();
    const lng = i18n.language;
    const isArabic = lng.startsWith('ar');

    // جلب الاسم بناءً على اللغة المتوفرة
    const nameEn = category?.name?.en || category?.name?.ar || '-';
    const nameAr = category?.name?.ar || category?.name?.en || '-';

    // جلب اسم القطاع
    const departmentName = isArabic
        ? (category?.department?.name?.ar || category?.department?.name?.en || '-')
        : (category?.department?.name?.en || category?.department?.name?.ar || '-');

    // جلب اسم الفئة الأب
    const parentName = isArabic
        ? (category?.parent?.name?.ar || category?.parent?.name?.en || '-')
        : (category?.parent?.name?.en || category?.parent?.name?.ar || '-');

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, category.id)}
                />
            </TableCell>

            {/* الرقم التسلسلي */}
            <TableCell align="start">{index + 1}</TableCell>

            {/* الاسم الإنجليزي */}
            <TableCell align="start" sx={{ fontWeight: 500 }}>
                {nameEn}
            </TableCell>

            {/* الاسم العربي */}
            <TableCell align="start" sx={{ fontWeight: 500 }}>
                {nameAr}
            </TableCell>

            {/* Slug */}
            <TableCell align="start">
                <Chip
                    label={category?.slug}
                    size="small"
                    variant="outlined"
                    sx={{ borderRadius: '6px', fontWeight: 'bold' }}
                />
            </TableCell>

            {/* القطاع */}
            <TableCell align="start">
                {departmentName}
            </TableCell>

            {/* الفئة الأب */}
            <TableCell align="start">
                {parentName}
            </TableCell>

            {/* الحالة */}
            <TableCell align="center">
                <Chip
                    label={category?.is_active ? (isArabic ? 'نشط' : 'Active') : (isArabic ? 'غير نشط' : 'Inactive')}
                    color={category?.is_active ? 'success' : 'error'}
                    size="small"
                    sx={{ borderRadius: '6px', minWidth: '70px' }}
                />
            </TableCell>

            {/* تاريخ الإضافة */}
            <TableCell align="start" sx={{ whiteSpace: 'nowrap' }}>
                {category?.created_at ? dayjs(category.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>

            {/* الإجراءات */}
            <TableCell align="right">
                <IconButton onClick={(event) => onMenuOpen(event, category)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default CategoriesTableRow;
